<template>
  <div :class="getSidebarClassName">
    <div class="world__name p-3">
      <h3>Réglages</h3>
      <b-icon
        id="sidebarCtl"
        class="sidebar-sidebar-ctl"
        v-if="$mq !== 'xl'"
        icon="text-indent-right"
        @click="handleOnClickMenuIcon"
      ></b-icon>
    </div>

    <div class="world__channels p-3">
      <div class="world__channel p-2 m-1" @click="handleClickProfile" :class="{ active: routeName === 'profile' }">
        <img :src="require(`@/assets/icons/hashtag.svg`)" />
        Profil
      </div>
      <div class="world__channel p-2 m-1" @click="handleClickNFTs" :class="{ active: routeName === 'my-nfts' }">
        <img :src="require(`@/assets/icons/hashtag.svg`)" />
        Mes NFTs
      </div>

      <div @click="goToLogout" class="world__channel p-2 m-1">
        <img :src="require(`@/assets/icons/hashtag.svg`)" />
        Se Déconnecter
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BIcon } from "bootstrap-vue";
import { CHANGE_EXPAND_MENU } from "@/store/actions";

export default {
  name: "ProfileBar",
  components: { BIcon },
  computed: {
    ...mapGetters("common", ["expandMenu"]),
    routeName() {
      return this.$route.name;
    },
    getSidebarClassName() {
      if (this.$mq === "xl") {
        return "serverbar";
      } else {
        if (this.expandMenu.expand) {
          return "serverbar";
        } else {
          return "serverbar reduce";
        }
      }
    },
  },
  methods: {
    ...mapActions("common", { changeExpandMenu: CHANGE_EXPAND_MENU }),
    handleOnClickMenuIcon() {
      this.changeExpandMenu({ expand: false });
    },
    handleClickProfile() {
      this.changeExpandMenu({ expand: false });
      this.$router.push({ name: "profile" });
    },
    handleClickNFTs() {
      this.changeExpandMenu({ expand: false });
      this.$router.push({ name: "my-nfts" });
    },
    goToLogout() {
      this.changeExpandMenu({ expand: false });
      this.$router.push({ name: "logout" });
    },
  },
};
</script>
